import React from 'react';
import Alert from '@reach/alert';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import { ALERT_TYPES } from 'constants/alerts/alert-types';
import styles from './StravaAlert.scss';

const StravaAlert = ({ children, className, severity, ...options }) => {
  return (
    <Alert
      className={clsx(styles.alert, styles[severity], className)}
      {...options}
    >
      {children}
    </Alert>
  );
};

StravaAlert.defaultProps = {
  className: null
};

StravaAlert.propTypes = {
  severity: PropTypes.oneOf(Object.values(ALERT_TYPES)).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default StravaAlert;
